import React, { useState, useEffect } from 'react';
import { getCampaigns } from '../services/api';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function Dashboard() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const data = await getCampaigns();
      setCampaigns(data.campaigns || []);
      setError(null);
    } catch (err) {
      setError('Failed to load campaigns');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = () => {
    const total = campaigns.length;
    const sent = campaigns.filter(c => c.status === 'sent').length;
    const totalRecipients = campaigns.reduce((sum, c) => sum + (c.total_recipients || 0), 0);
    const totalSent = campaigns.reduce((sum, c) => sum + (c.sent_count || 0), 0);
    const totalOpens = campaigns.reduce((sum, c) => sum + (c.open_count || 0), 0);
    const openRate = totalSent > 0 ? ((totalOpens / totalSent) * 100).toFixed(1) : 0;

    return { total, sent, totalRecipients, totalSent, totalOpens, openRate };
  };

  const stats = calculateStats();

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>

      {error && <div className="error">{error}</div>}

      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Campaigns</h3>
          <div className="value">{stats.total}</div>
        </div>
        <div className="stat-card">
          <h3>Campaigns Sent</h3>
          <div className="value">{stats.sent}</div>
        </div>
        <div className="stat-card">
          <h3>Total Recipients</h3>
          <div className="value">{stats.totalRecipients}</div>
        </div>
        <div className="stat-card">
          <h3>Emails Sent</h3>
          <div className="value">{stats.totalSent}</div>
        </div>
        <div className="stat-card">
          <h3>Total Opens</h3>
          <div className="value">{stats.totalOpens}</div>
        </div>
        <div className="stat-card">
          <h3>Open Rate</h3>
          <div className="value">{stats.openRate}%</div>
        </div>
      </div>

      <div className="card">
        <h2>Recent Campaigns</h2>
        {campaigns.length === 0 ? (
          <p>No campaigns yet. Create your first campaign to get started!</p>
        ) : (
          <ul className="campaign-list">
            {campaigns.slice(0, 5).map(campaign => (
              <li key={campaign.campaign_id} className="campaign-item">
                <h3>{campaign.name}</h3>
                <div className="meta">
                  <span className={`status-badge status-${campaign.status}`}>
                    {campaign.status}
                  </span>
                  <span style={{ marginLeft: '1rem' }}>
                    {campaign.sent_count || 0} / {campaign.total_recipients || 0} sent
                  </span>
                  {campaign.sent_count > 0 && (
                    <span style={{ marginLeft: '1rem' }}>
                      {campaign.open_count || 0} opens ({campaign.sent_count > 0 ? ((campaign.open_count || 0) / campaign.sent_count * 100).toFixed(1) : 0}%)
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
